import React from 'react';

import styles from './HoverTooltip.scss';

const HoverTooltip = ({tooltip, name, pullTop, leftPosition}) => {

	return (
		<div id={name}
			 className={`${styles.container} ${pullTop === true && styles.pullTop} ${leftPosition ? styles.left : ''}`}>
			<p dangerouslySetInnerHTML={{
				__html: tooltip
			}}/>
			<div className={styles.tailShadow}/>
			<div className={styles.tail1}/>
			<div className={styles.tail2}/>
		</div>
	);
};
export {styles as HoverTooltipStyles};
export default HoverTooltip;